export default {
  listCategory: [],
  listProduct: [],
  listRegion: [],
  listCluster : [],
  listAttribute: [],
  accessToken: sessionStorage.getItem('accessToken'),
}
